import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { action, makeObservable } from 'mobx'
import PropTypes from 'prop-types'
import i18n from 'i18next'

import Input from '../../form/Input'
import ENUM from '../ENUM'
import Select from '../../form/Select'

@observer
class InheritedSlideConfig extends Component {
    constructor(props) {
        super(props)
        const { presentationStore, config } = props
        const { question, slide } = config
        const { questionTypeCode } = question
        this.questionOptions = presentationStore.getConfigFormOptions(questionTypeCode, question, {})
        this.presentationStore = props.presentationStore

        slide.display = this.questionOptions.filters
            .find((item) => item.name === ENUM().display).options[0].value

        makeObservable(slide)
    }

    onChangeHandler = ({ name, value }) => {
        const { config } = this.props
        const { slide } = config

        slide[name] = value
    }

    @action
    updatePowerpointObject = (fieldName, {
        name,
        value,
    }) => {
        const { config } = this.props
        const { slide } = config

        slide.comparisonSurveyIds = slide.comparisonSurveyIds
            .slice()
            .map((benchmark) => {
                if (benchmark.value === name) {
                    benchmark.checked = value
                }
                return benchmark
            })
    }

    render() {
        const {
            config,
            presentationStore,
        } = this.props

        const { slide } = config
        const { childPageQuestionId, comparisonSurveyIds } = slide
        const { inheritedOptions } = presentationStore

        console.log('render INheritedSlideConfig')

        return (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div className="question-select-col">
                    <div>
                        <Select
                            showDisabled
                            label={i18n.t('powerpoint.labels.parentQuestion')}
                            value={{
                                value: '',
                                label: inheritedOptions.find(({ value }) => value === childPageQuestionId).parentLabel,
                            }}
                        />
                    </div>
                    <div>
                        <Select
                            label={i18n.t('powerpoint.labels.selectChildQuestion')}
                            options={inheritedOptions}
                            onBlur={this.onChangeHandler}
                            defaultValue={childPageQuestionId}
                        />
                    </div>

                </div>
                <div className="question-select-col">
                    <div>
                        <Select
                            label={i18n.t('powerpoint.labels.ranking')}
                            options={this.questionOptions.filters
                                .find((item) => item.name === ENUM().ranking).options}
                            onBlur={this.onChangeHandler}
                            // value={ranking}
                        />
                    </div>
                    <div>
                        <Input
                            label={i18n.t(`powerpoint.labels.${ENUM().removeBaseLimit}`)}
                            onBlur={this.onChangeHandler}
                            name={ENUM().removeBaseLimit}
                            type="number"
                            className="number-input"
                        />
                    </div>
                    <div>
                        <Select
                            label={i18n.t(`powerpoint.labels.${ENUM().display}`)}
                            options={this.questionOptions.filters
                                .find((item) => item.name === ENUM().display).options}
                            onBlur={this.onChangeHandler}
                            defaultValue={slide.display}
                        />
                    </div>

                </div>
                {/* temporarily disabling comparison years */}
                {/* <Col xs={1}>
                    <CheckboxCol
                        key={`comparisonSurveyIds_${slide.id}`}
                        id={`comparisonSurveyIds_${slide.id}`}
                        callback={this.updatePowerpointObject}
                        config={config}
                        title={i18n.t(`powerpoint.labels.${ENUM().comparisonSurveyIds}`)}
                        grid={{ xs: 1 }}
                        name="comparisonSurveyIds"
                        checkboxes={comparisonSurveyIds}
                        cssClass="checkbox-cols"
                    />
                </Col> */}
            </div>
        )
    }
}

InheritedSlideConfig.propTypes = {
    config: PropTypes.object.isRequired,
    inheritedOptions: PropTypes.array.isRequired,
}

export default InheritedSlideConfig
